import { useRef } from "react"
import { useHistory, useLocation } from "react-router-dom"

export function useLocationReload() {
  const key = useLocationReloadKey()
  const trigger = useLocationReloadTrigger()

  return [key, trigger] as const
}

export function useLocationReloadKey() {
  const location = useLocation<{ reloadKey?: number }>()
  const reloadKey = useRef(location.state?.reloadKey)
  reloadKey.current = location.state?.reloadKey ?? reloadKey.current

  return reloadKey.current
}

export function useLocationReloadTrigger() {
  const history = useHistory()

  const triggerReload = () => {
    history.replace({ search: location.search, state: { reloadKey: Math.random() } })
  }

  return triggerReload
}
